import { useContext } from 'react';
import PropTypes from 'prop-types';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import { ReactComponent as GoogleAuthenticatorIcon } from 'assets/google-authenticator-icon.svg';
import { ReactComponent as WhatsAppIcon } from 'assets/whatsapp-logo.svg';
import { ReactComponent as SmsIcon } from 'assets/sms-icon.svg';
import { ReactComponent as TransferraAppIcon } from 'assets/transferra-app-icon.svg';
import { TWO_FACTOR_AUTH_TYPES } from 'components/common/constants';
import i18nContext from 'components/i18n-context';
import { getAvailableConfirmationTypes } from 'services/authUtils';
import Button from 'uikit/Button/Button';

const Manage2FA = ({ userStore, availableConfirmationTypes }) => {
  const i18n = useContext(i18nContext);
  const enableGoogle2FA = () => userStore.enableGoogle2FA();
  const reactivateGoogle2FA = () => userStore.reactivateGoogle2FA();
  const disableGoogle2FA = () => userStore.disableGoogle2FA();
  const activateWhatsApp2FA = () => userStore.activateWhatsApp2FA();
  const activateSms2FA = () => userStore.activateSms2FA();

  const isGoogle2FAEnabled =
    availableConfirmationTypes && availableConfirmationTypes?.includes(TWO_FACTOR_AUTH_TYPES.GOOGLE_AUTH);
  const isWhatsApp2FAEnabled =
    availableConfirmationTypes && availableConfirmationTypes?.includes(TWO_FACTOR_AUTH_TYPES.WHATSAPP);
  const isSms2FAEnabled = availableConfirmationTypes && availableConfirmationTypes?.includes(TWO_FACTOR_AUTH_TYPES.SMS);
  const isPushNotifications2FAEnabled =
    availableConfirmationTypes && availableConfirmationTypes?.includes(TWO_FACTOR_AUTH_TYPES.PUSH_NOTIFICATION);

  return (
    <div className={'manage2fa-main-wrapper'}>
      <div className={'settings-container-manage2fa'}>
        <div className={'manage2fa-row-block'}>
          <div className={'manage2fa-wrapper'}>
            <div className={'manage2fa-info-block'}>
              {isGoogle2FAEnabled ? (
                <p className={'manage2fa-status manage2fa-status-enabled'}>
                  {i18n.getMessage('settings.manage2fa.status.enabled')}
                </p>
              ) : (
                <p className={'manage2fa-status manage2fa-status-disabled'}>
                  {i18n.getMessage('settings.manage2fa.status.disabled')}
                </p>
              )}
              <div className={'manage2fa-title-wrapper'}>
                <p className={'manage2fa-title'}>{i18n.getMessage('settings.manage2fa.google2fa.title')}</p>
                <div className={'google2fa-icon-wrapper'}>
                  <GoogleAuthenticatorIcon className={'google2fa-icon'} />
                </div>
              </div>
              <p className={'manage2fa-description'}>{i18n.getMessage('settings.manage2fa.google2fa.description')}</p>
            </div>
            <div className={'manage2fa-actions-wrapper'}>
              <Button
                className={`manage2fa-button ${isGoogle2FAEnabled && userStore.isGoogle2FAActivated ? '' : 'enable-button'}`}
                roleType={'button'}
                onClick={enableGoogle2FA}
              >
                {isGoogle2FAEnabled && userStore.isGoogle2FAActivated
                  ? i18n.getMessage('settings.manage2fa.button.resetCode')
                  : i18n.getMessage('settings.manage2fa.button.enable')}
              </Button>
              {isGoogle2FAEnabled && (
                <Button className={'manage2fa-button disable-button'} roleType={'button'} onClick={disableGoogle2FA}>
                  {i18n.getMessage('settings.manage2fa.button.disable')}
                </Button>
              )}
            </div>
          </div>

          <div className={'manage2fa-wrapper'}>
            <div className={'manage2fa-info-block'}>
              {isSms2FAEnabled ? (
                <p className={'manage2fa-status manage2fa-status-enabled'}>
                  {i18n.getMessage('settings.manage2fa.status.enabled')}
                </p>
              ) : (
                <p className={'manage2fa-status manage2fa-status-disabled'}>
                  {i18n.getMessage('settings.manage2fa.status.disabled')}
                </p>
              )}
              <div className={'manage2fa-title-wrapper'}>
                <p className={'manage2fa-title'}>{i18n.getMessage('settings.manage2fa.securityCode.title')}</p>
                <div className={'google2fa-icon-wrapper'}>
                  <SmsIcon className={'google2fa-icon'} />
                </div>
              </div>
              <p className={'manage2fa-description'}>
                {i18n.getMessage('settings.manage2fa.securityCode.description')}
              </p>
            </div>
          </div>

          {/* For next releases */}
          {/*<div className={'manage2fa-wrapper'}>*/}
          {/*  <div className={'manage2fa-info-block'}>*/}
          {/*    {isWhatsApp2FAEnabled ? (*/}
          {/*      <p className={'manage2fa-status manage2fa-status-enabled'}>*/}
          {/*        {i18n.getMessage('settings.manage2fa.status.enabled')}*/}
          {/*      </p>*/}
          {/*    ) : (*/}
          {/*      <p className={'manage2fa-status manage2fa-status-disabled'}>*/}
          {/*        {i18n.getMessage('settings.manage2fa.status.disabled')}*/}
          {/*      </p>*/}
          {/*    )}*/}
          {/*    <div className={'manage2fa-title-wrapper'}>*/}
          {/*      <p className={'manage2fa-title'}>{i18n.getMessage('settings.manage2fa.whatsapp.title')}</p>*/}
          {/*      <div className={'google2fa-icon-wrapper'}>*/}
          {/*        <WhatsAppIcon className={'google2fa-icon'} />*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    {isWhatsApp2FAEnabled && !userStore.isWhatsApp2FAActivated && (*/}
          {/*      <p className={'manage2fa-description'}>*/}
          {/*        {i18n.getMessage('settings.manage2fa.whatsapp.description')}*/}
          {/*      </p>*/}
          {/*    )}*/}
          {/*    {isWhatsApp2FAEnabled && userStore.isWhatsApp2FAActivated && (*/}
          {/*      <p className={'manage2fa-description'}>*/}
          {/*        {i18n.getMessage('settings.manage2fa.whatsapp.defaultDescription')}*/}
          {/*      </p>*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*  <div className={'manage2fa-actions-wrapper'}>*/}
          {/*    {isWhatsApp2FAEnabled && !userStore.isWhatsApp2FAActivated && (*/}
          {/*      <Button className={'manage2fa-button'} roleType={'button'} onClick={activateWhatsApp2FA}>*/}
          {/*        {i18n.getMessage('settings.manage2fa.button.setAsDefault')}*/}
          {/*      </Button>*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/* For next releases */}
        </div>

        {/*<div className={'manage2fa-row-block'}>*/}
        {/*<div className={'manage2fa-wrapper'}>*/}
        {/*  <div className={'manage2fa-info-block'}>*/}
        {/*    {isSms2FAEnabled ? (*/}
        {/*      <p className={'manage2fa-status manage2fa-status-enabled'}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.status.enabled')}*/}
        {/*      </p>*/}
        {/*    ) : (*/}
        {/*      <p className={'manage2fa-status manage2fa-status-disabled'}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.status.disabled')}*/}
        {/*      </p>*/}
        {/*    )}*/}
        {/*    <div className={'manage2fa-title-wrapper'}>*/}
        {/*      <p className={'manage2fa-title'}>{i18n.getMessage('settings.manage2fa.sms.title')}</p>*/}
        {/*      <div className={'google2fa-icon-wrapper'}>*/}
        {/*        <SmsIcon className={'google2fa-icon'} />*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    {isSms2FAEnabled && !userStore.isSms2FAActivated && (*/}
        {/*      <p className={'manage2fa-description'}>{i18n.getMessage('settings.manage2fa.sms.description')}</p>*/}
        {/*    )}*/}
        {/*    {isSms2FAEnabled && userStore.isSms2FAActivated && (*/}
        {/*      <p className={'manage2fa-description'}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.sms.defaultDescription')}*/}
        {/*      </p>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*  <div className={'manage2fa-actions-wrapper'}>*/}
        {/*    {isSms2FAEnabled && !userStore.isSms2FAActivated && (*/}
        {/*      <Button className={'manage2fa-button'} roleType={'button'} onClick={activateSms2FA}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.button.setAsDefault')}*/}
        {/*      </Button>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*</div>*/}

        {/* For next releases */}
        {/*<div className={'manage2fa-wrapper'}>*/}
        {/*  <div className={'manage2fa-info-block'}>*/}
        {/*    {isPushNotifications2FAEnabled ? (*/}
        {/*      <p className={'manage2fa-status manage2fa-status-enabled'}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.status.enabled')}*/}
        {/*      </p>*/}
        {/*    ) : (*/}
        {/*      <p className={'manage2fa-status manage2fa-status-disabled'}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.status.disabled')}*/}
        {/*      </p>*/}
        {/*    )}*/}
        {/*    <div className={'manage2fa-title-wrapper'}>*/}
        {/*      <p className={'manage2fa-title'}>{i18n.getMessage('settings.manage2fa.transferraApp.title')}</p>*/}
        {/*      <div className={'google2fa-icon-wrapper'}>*/}
        {/*        <TransferraAppIcon className={'google2fa-icon'} />*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    {!isPushNotifications2FAEnabled && (*/}
        {/*      <p className={'manage2fa-description'}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.transferraApp.enabledDescription')}*/}
        {/*      </p>*/}
        {/*    )}*/}
        {/*    {isPushNotifications2FAEnabled && !userStore.isPushNotifications2FAActivated && (*/}
        {/*      <p className={'manage2fa-description'}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.transferraApp.description')}*/}
        {/*      </p>*/}
        {/*    )}*/}
        {/*    {isPushNotifications2FAEnabled && userStore.isPushNotifications2FAActivated && (*/}
        {/*      <p className={'manage2fa-description'}>*/}
        {/*        {i18n.getMessage('settings.manage2fa.transferraApp.defaultDescription')}*/}
        {/*      </p>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*  <div className={'manage2fa-actions-wrapper'} />*/}
        {/*</div>*/}
        {/*</div>*/}
        {/* For next releases */}
      </div>
    </div>
  );
};

Manage2FA.propTypes = {
  userStore: MobXPropTypes.observableObject,
  availableConfirmationTypes: PropTypes.string
};

export default inject('userStore')(observer(Manage2FA));
